<template>
<div>
  <!-- Side bar navigation -->
  <div :class="{ drawerActive: menuIsVisible }">
  <div class="overlay-body" @click="toggleMenu"></div>
  <nav-bar v-if="userIsLogged" :menu-is-Visible="menuIsVisible"></nav-bar>
  </div>
  <!-- Header elements -->
  <div>
    <!-- Unlogged menu -->
    <div v-if="setting === 'initial'"><img src="/static/logo.svg" class="header-logo"></div>
    <!-- Logged in menu -->
    <div v-else-if="setting === 'appNavigation'" class="search-header-container">
      <div class="app-navigation-links">
        <img src="/static/menu.svg" class="header-menu-icon" @click="toggleMenu">
        <router-link to="/lista-de-analisis"><img src="/static/logo.svg" class="logged-header-logo"></router-link>
      </div>
      <!-- Admin links -->
      <div v-show="userIsAdmin" class="admin-header-items">
        <router-link to="/lista-de-asesores" class="admin-header-link">Asesores</router-link>
        <router-link to="/lista-de-analisis" class="admin-header-link">Portafolios</router-link>
      </div>
      <!-- Searchbar -->
      <el-input v-show="hideSearchbar" v-model="query" :placeholder="inputPlaceholder"><i slot="prefix" class="el-input__icon el-icon-search"></i>
      <i v-if="query !== ''" slot="suffix" class="el-input__icon el-icon-circle-close-outline" @click="resetInput"></i></el-input>
    </div>
    <!-- Portfolio Navigation -->
    <div v-else class="search-header-container">
      <div class="app-navigation-links">
        <img src="/static/menu.svg" class="header-menu-icon" @click="toggleMenu">
        <router-link to="/lista-de-analisis"><img src="/static/logo.svg" class="logged-header-logo"></router-link>
      </div>
      <div class="portfolio-navigation-links">
        <span v-on:click="editPortfolio">Editar</span>
        <span v-on:click="updatePortfolio">Actualizar</span>
        <span v-on:click="goToPrintable">Generar PDF</span>
        <span v-on:click="sendPortfolioUrl">Enviar enlace</span>
      </div>
    </div>
  </div>
  <!-- Dialog send url -->
  <el-dialog title="Enviar enlace" class="send-url-container" :visible.sync="displaySendUrlDialog">
    <div>
      <el-form :model="sendUrlData" status-icon :rules="rules" ref="sendShareUrl">
        <span> Email </span>
        <el-form-item prop="email">
          <el-input class="send-url" placeholder="" prefix-icon="el-icon-edit" v-model="sendUrlData.email" auto-complete="off"></el-input>
        </el-form-item>
        <el-button type="primary" v-on:click="validateAndSumbit('sendShareUrl')" style="width:100%; background-color:#2873DE; border:none">Enviar</el-button>
      </el-form>
    </div>
  </el-dialog>
</div>
</template>

<script>
import NavBar from '@/components/NavBar';
import { getAdvisorsByQuery, getAllAdvisors, getPortfoliosByAdvisorId, getAllPortfolios, savePortfolios,
  upgradePortfolio, sendUrl, getPortfolioById } from '@/graphql'

export default {
  name: 'AppHeader',
  components: {
    'nav-bar': NavBar,
  },
  data() {
    return {
      query: '',
      displaySendUrlDialog: false,
      sendUrlData: {
        email: ''
      },
      rules: {
        email: [
          {
            required: true,
            message: "Debes proporcionar un email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Es necesario un email válido, ejemplo@email.com",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    query: function (value) {
      if (value !== '') {
        this.querySearch(value)
      } else {
        this.fetchCleanData(this.searchConfiguration)
      }
    },
    displaySendUrlDialog: function (value) {
      if (!value) {
        this.$refs["sendShareUrl"].resetFields();
      }
    }
  },
  methods: {
    toggleMenu() {
      this.$store.dispatch( 'toggleMenu' , !this.menuIsVisible )
    },
    resetInput() {
      this.query = ''
      this.fetchCleanData(this.searchConfiguration)
    },
    fetchCleanData (searchType) {
      if (searchType === 'portfolios') {
        // Find portfolios
        if (!this.userIsAdmin) {
          this.$apollo.query({
            query: getPortfoliosByAdvisorId,
            variables: {
              advisorId: this.$store.getters.userInfo.id
            },
            fetchPolicy: 'network-only'
          })
          .then((data) =>  this.$store.dispatch( 'savePortfolios', data.data.portfoliosByAdvisor)
          ).catch((error) => { console.log(error) })
        } else {
          this.$apollo.query({
            query: getAllPortfolios,
            fetchPolicy: 'network-only'
          })
          .then((data) =>  this.$store.dispatch( 'savePortfolios', data.data.allPortfolios)
          ).catch((error) => { console.log(error) })
        }
        // Find advisors
      } else {
        this.$apollo.query({
          query: getAllAdvisors,
          fetchPolicy: 'network-only'
        }).then((data) => this.$store.dispatch( 'saveAdvisors', data.data.allAdvisors))
      }
    },
    querySearch (query) {
      // search data by current section
      // portfolios
      if (this.searchConfiguration === 'portfolios') {
        // search by current user type
        if(this.userIsAdmin) {
          this.$apollo.query({
            query: getPortfoliosByAdvisorId,
            variables: {
              query: this.query
            },
            fetchPolicy: 'network-only'
          })
          .then((data) =>  this.$store.dispatch( 'savePortfolios', data.data.portfoliosByAdvisor)
          ).catch((error) => { console.log(error) })
        } else {
          this.$apollo.query({
            query: getPortfoliosByAdvisorId,
            variables: {
              advisorId: this.$store.getters.userInfo.id,
              query: this.query
            },
            fetchPolicy: 'network-only'
          })
          .then((data) =>  this.$store.dispatch( 'savePortfolios', data.data.portfoliosByAdvisor)
          ).catch((error) => { console.log(error) })
        }
      //  advisors
      } else {
        this.$apollo.query({
          query: getAdvisorsByQuery,
          variables: {
            query: this.query
          },
          fetchPolicy: 'network-only'
        })
        .then((data) =>  this.$store.dispatch( 'saveAdvisors', data.data.findAdvisors)
        ).catch((error) => { console.log(error) })
      }
    },
    editPortfolio () {
      const id = this.$route.params.id
      this.$store.dispatch('setSelectedPortfolio', id)
      this.$apollo.query({ query: getPortfolioById,
        variables: {id}
      }).then(data => this.redirectToForm(data.data.portfolioById))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      })
    },
    redirectToForm (portfolio) {
      this.$store.dispatch('setFormMode', 3)
      this.$store.dispatch("preloadPortfolioForm", portfolio)
      this.$router.push('/registro-datos-generales')
    },
    goToPrintable (event) {
      const route = this.$router.resolve(`/imprimir-analisis-portafolio/${this.$route.params.id}`)
      window.open(route.href, '_blank');
    },
    updatePortfolio (event) {
      this.$apollo.mutate({ mutation: upgradePortfolio,
        variables: {portfolioId: this.$route.params.id}
      }).then(data => this.requestSuccess(data.data.upgradePortfolio.message))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    sendPortfolioUrl () {
      const portfolioId = parseInt(this.$route.params.id)
      // this.sendUrlData.email = ''
      // this.$refs["sendShareUrl"].resetFields();
      const userEmail = this.$store.getters.currentPortfolioAnalysis.email
      if (userEmail) {
        this.$apollo.query({ query: sendUrl,
          variables: { portfolioId, email: userEmail },
          fetchPolicy: 'network-only'
        })
        .then(data => this.requestSuccess(data.data.sendAnalysisUrl.msg))
        .catch(() => {
          this.$message({
            type: "error",
            message: "Ocurrió un error intenta más tarde"
          });
        })
      } else {
        this.displaySendUrlDialog = true
      }
    },
    validateAndSumbit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.displaySendUrlDialog = false
          const email = this.sendUrlData.email
          this.sendUrl(email)
        } else {
          return false;
        }
      })
    },
    sendUrl(email) {
      const portfolioId = this.$route.params.id
      this.sendUrlData.email = ''
      this.$refs["sendShareUrl"].resetFields();
      this.$apollo.query({ query: sendUrl,
        variables: { portfolioId, email },
        fetchPolicy: 'network-only'
      })
      .then(data => this.requestSuccess(data.data.sendAnalysisUrl.msg))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    requestSuccess(message) {
      this.$message({type: "success", message})
    }
  },
  computed: {
    userIsLogged: function () {
      return this.$store.getters.userIsLogged
    },
    userIsAdmin: function () {
      return this.$store.getters.userIsAdmin
    },
    menuIsVisible: function () {
      return this.$store.getters.menuIsVisible
    },
    hideSearchbar: function () {

        let hide = true;

        if (this.$route.fullPath.startsWith('/registro')){
            hide = false;
        }else if (this.$route.fullPath.startsWith('/validacion')) {
            hide = false;
        }else if (this.$route.fullPath.startsWith('/links')) {
            hide = false;
        }else if (this.$route.fullPath.startsWith('/calculadora')) {
            hide = false;
        }


        return hide
    },
    searchConfiguration: function () {
      return this.$route.name === 'Advisors' ?  'advisors' : 'portfolios'
    },
    inputPlaceholder: function () {
      return this.$route.name === 'Advisors' ? 'Buscar nombre o correo' : 'Busca no. de portafolio o alias'
    },
    portfolioContractNumber: function () {
      return this.$store.getters.currentPortfolioAnalysis.contractNumber || ''
    },
    setting: function () {
      const currentComponent = this.$store.state.route.name
      if (this.$route.params.id && this.userIsLogged) {
        return 'portfolioNavigation'
      } else if (this.userIsLogged) {
        return 'appNavigation'
      } else {
        return 'initial'
      }
    }
  },
};
</script>

<!-- Component styles if required -->
<style scoped>
  .el-input {
    width: 70%;
  }

  .header-logo {
    margin: 7px;
  }

  .header-menu-icon {
    margin: 0 10px 0 10px;
  }

  .logged-header-logo {
    display: flex;
    margin: 0 10px;
  }

  .app-navigation-links {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .portfolio-navigation-links span {
    margin: 0 10px;
    cursor: pointer;
  }

  .portfolio-navigation-links span:active {
    color: #001F5C;
  }

  .search-header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .overlay-body {
    display: none;
    width: 100vw;
    height: 120vh;
    background:#000000ab;
    position: fixed;
    z-index: 70;
    left: 0;
    top: 0;
    cursor: pointer;
  }

  .drawerActive .overlay-body{
    display: block;
  }

  .drawerActive .drawer-nav {
    transform: translateX(0);
  }

  .el-input__icon {
    color: #001F5C;
    font-size: 20px;
    font-weight: bold;
  }

  .admin-header-items {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
  }

  .admin-header-link {
    color: #4A4A4A;
    font-size: 16px;
    text-decoration: none;
    margin: 0 15px;
  }

  .router-link-exact-active {
    color: #001F5C;
    font-weight: bold;
  }

  .send-url-container {
    text-align: left;
  }

  .send-url-container .el-dialog__body {
    padding: 0;
  }

  .send-url.el-input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue